let clientConfig = {
  origin: {
    '1': 'm-game.qidian.com',
    '2': 'm-game.book.qq.com',
    '3': 'p-game.qidian.com'
  },
  sdkName: {
    '1': 'qdnative',
    '2': 'androidqq',
    '3': 'qdnative'
  },
  cssClassName: {
    '1': 'S_QD_A',
    '2': 'S_QQ_A',
    '3': 'S_QD_I'
  },
  cssBtnColor: {
    '1': 'B_r',
    '2': 'B_b',
    '3': 'B_r'
  },
  cssBgColor: {
    '1': 'BG_r',
    '2': 'BG_b',
    '3': 'BG_r'
  },
  appName: {
    '1': '起点读书',
    '2': 'QQ阅读',
    '3': '起点读书'
  },
  coinName: {
    '1': '起点币',
    '2': '书币',
    '3': '阅点'
  },
  clientJsUrls: {
    '1': [
      '../static/js/qda/common.js',
      '../static/js/qda/qd.js',
      '../static/js/qda/qdnative.js'
    ],
    '2': [
      '../static/js/qqa/common.js',
      '../static/js/qqa/jsbridge.js',
      '../static/js/qqa/androidqq.js'
    ],
    '3': [
      '../static/js/qdi/common.js',
      '../static/js/qdi/qd.js',
      '../static/js/qdi/qdnative.js'
    ]
  }
}

if (process.env.NODE_ENV === 'development') {
  clientConfig.httpsHost = {
    '1': 'https://devm-game.qidian.com/',
    '2': 'https://devm-game.book.qq.com/',
    '3': 'https://devp-game.qidian.com/'
  }
  clientConfig.apiHost = {
    '1': 'https://devi-game.qidian.com/',
    '2': 'https://devi-game.book.qq.com/',
    '3': 'https://devi-game.qidian.com/'
  }

  clientConfig.lyApiHost = {
    '1': 'https://lygametest.qidian.com/',
    '2': 'https://lygametest.book.qq.com/',
    '3': 'https://lygametest.qidian.com/'
  }

  clientConfig.appHost = {
    '1': 'QDReader://devm-game.qidian.com/',
    '2': 'uniteqqreader://webpage/game/https://devm-game.book.qq.com/'
  }
  // clientConfig.apiHost = {
  //   '1': 'https://debugi-game.qidian.com/',
  //   '2': 'https://debugi-game.book.qq.com/',
  //   '3': 'https://debugi-game.qidian.com/'
  // }
  clientConfig.mtaSid = {
    '1': '500555855',
    '2': '500513957',
    '3': '500543812'
  }
  clientConfig.mtaCid = {
    '1': '500627221',
    '2': '500633477',
    '3': '500634644'
  }
  clientConfig.mtaHid = {
    '1': '"5b7fbfadf3938"',
    '2': '"5b7d0e1328948"',
    '3': '"5b83ce214d952"'
  }
  clientConfig.newAppHosts = {
    1: 'qdgame://qdgametest.qidian.com/?_viewmode=4',
    2: 'uniteqqreader://webpage/game/https://qqgametest.book.qq.com/?_viewmode=1',
    3: 'https://qdgametest.qidian.com/'
  }
  clientConfig.newGameHosts = {
    1: 'qdgame://qdgametest.qidian.com',
    2: 'uniteqqreader://webpage/game/https://qqgametest.book.qq.com',
    3: 'QDReader://qdgametest.qidian.com'
  }
  clientConfig.newGameNoSceHosts = {
    1: 'https://qdgametest.qidian.com',
    2: 'https://qqgametest.book.qq.com',
    3: 'https://qdgametest.qidian.com'
  }
} else {
  clientConfig.httpsHost = {
    '1': 'https://m-game.qidian.com/',
    '2': 'https://m-game.book.qq.com/',
    '3': 'https://p-game.qidian.com/'
  }
  clientConfig.apiHost = {
    '1': 'https://i-game.qidian.com/',
    '2': 'https://i-game.book.qq.com/',
    '3': 'https://i-game.qidian.com/'
  }

  clientConfig.lyApiHost = {
    '1': 'https://lygame.qidian.com/',
    '2': 'https://lygame.book.qq.com/',
    '3': 'https://lygame.qidian.com/'
  }

  clientConfig.appHost = {
    '1': 'QDReader://m-game.qidian.com/',
    '2': 'uniteqqreader://webpage/game/https://m-game.book.qq.com/'
  }
  clientConfig.mtaSid = {
    '1': '500555853',
    '2': '500521695',
    '3': '500545454'
  }
  clientConfig.mtaCid = {
    '1': '500583589',
    '2': '500539047',
    '3': '500581439'
  }
  clientConfig.mtaHid = {
    '1': '"5b7fc4893fc58"',
    '2': '"5b7fc24dbe901"',
    '3': '"5b83ce5a465e8"'
  }
  clientConfig.newAppHosts = {
    1: 'qdgame://qdgame.qidian.com/?_viewmode=4',
    2: 'uniteqqreader://webpage/game/https://qqgame.book.qq.com/?_viewmode=1',
    3: 'https://qdgame.qidian.com/'
  }
  clientConfig.newGameHosts = {
    1: 'qdgame://qdgame.qidian.com',
    2: 'uniteqqreader://webpage/game/https://qqgame.book.qq.com',
    3: 'QDReader://qdgame.qidian.com'
  }
  clientConfig.newGameNoSceHosts = {
    1: 'https://qdgame.qidian.com',
    2: 'https://qqgame.book.qq.com',
    3: 'https://qdgame.qidian.com'
  }
}

export default clientConfig



// WEBPACK FOOTER //
// ./src/v2/config/client.js